import React from 'react';

import { LoginByPasswordFormStep } from './LoginByPasswordFormStep';
import { LoginByCodeFormStep } from './LoginByCodeFormStep';

import type { UseStepperReturnType } from '../../../../../../hooks/useStepper';

export type LoginByEmailFormStep3Props = UseStepperReturnType;

// We are using the function name
// Replace if needed
const componentMapping = {
  [LoginByCodeFormStep.name]: (props: LoginByEmailFormStep3Props) => (
    <LoginByCodeFormStep
      {...props}
    />
  ),
  [LoginByPasswordFormStep.name]: (props: LoginByEmailFormStep3Props) => (
    <LoginByPasswordFormStep
      {...props}
    />
  ),
};

export const LoginByEmailFormStep3 = (props: LoginByEmailFormStep3Props) => {
  const Component = componentMapping[props.meta.stepName] || null;

  if (!Component) {
    return null;
  }

  return (
    <>
      <Component
        {...props}
      />
    </>
  );
};
